/**
* 基础菜单 新增售后单
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <div class="block">
          <el-date-picker
            v-model="order_complete_time"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.order_code" placeholder="订单编号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.cust_mobile" placeholder="会员账号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.service_type" placeholder="售后类型" clearable>
          <el-option label="退货" value="90"></el-option>
          <el-option label="维修" value="92"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.order_status" placeholder="订单状态" clearable>
          <el-option label="待收货" value="105"></el-option>
          <el-option label="已完成" value="106"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 80%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="order_code" label="订单编号" min-width="200">
          <template slot-scope="scope">
            <span style="color: #1989FA;cursor: pointer" @click="gotoOrderDetail(scope.row.id,scope.row.order_code)">
              {{ scope.row.order_code }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="submit_time" label="订单提交时间" width="200">
        </el-table-column>
        <el-table-column prop="settle_amount" label="订单实付金额" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.settle_amount||scope.row.settle_amount==0">￥{{scope.row.settle_amount}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="cust_mobile" label="会员账号" width="200">
        </el-table-column>
        <el-table-column prop="pay_success_time" label="订单支付时间" width="200">
        </el-table-column>
        <el-table-column prop="order_status" label="订单状态" width="100">
          <template slot-scope="scope">
            <div plain v-if="scope.row.order_status==100">已取消</div>
            <div plain style="color: #67C23A" v-if="scope.row.order_status==101">待付款</div>
            <div plain style="color: #F56C6C" v-if="scope.row.order_status==105">待收货</div>
            <div plain style="color: #409eff" v-if="scope.row.order_status==106">已完成</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :visible.sync="couponDialogVisible"
               width="60%"
               top="8vh"
               center>
      <div>
        <div class="layout">订单 {{ order_code }}</div>
        <div style="height: 530px;overflow-y: auto">
          <el-form :inline="true" :model="addsaleFormInline" class="user-search">
            <el-form-item label="">
              <el-input size="small" v-model="addsaleFormInline.sale_name" placeholder="销售名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="addsaleFormInline.product_code" placeholder="商品编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="addsaleFormInline.send_status" placeholder="发货状态" clearable>
                <el-option label="未发货" value="0" v-if="disabled"></el-option>
                <el-option label="已发货" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="couponSearch">查询</el-button>
            </el-form-item>
          </el-form>
          <div style="height: 460px;overflow-y: auto">
            <el-table size="small" :data="couponlistData" highlight-current-row v-loading="loading" border
                      @cell-dblclick="couponCellDbClick" @selection-change="handleSelectionChange"
                      :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                      element-loading-text="拼命加载中" style="width: 100%;">
              <el-table-column align="center" type="selection" width="60">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{couponpageparm.pageSize * (couponpageparm.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="product_code" label="商品编码" min-width="190" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="sale_name" label="销售名称" width="300" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="send_status" label="发货状态" width="100">
                <template slot-scope="scope">
                  <div plain style="color: #F56C6C" v-if="scope.row.send_status=='0'">未发货</div>
                  <div plain style="color: #409eff" v-if="scope.row.send_status=='1'">已发货</div>
                </template>
              </el-table-column>
              <el-table-column prop="service_num" label="售后数量" width="160">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.service_num" @change="handleChange" :min="1"
                                   :max="scope.row.maxnum" size="mini"></el-input-number>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="couponpageparm" @callFather="couponCallFather"></Pagination>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="refundEdit()">确 定</el-button>
            <el-button @click="couponDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    serviceOrderList,
    serviceOrderListDetail,
    serviceAdd
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {param} from '../../api/commonMG'
  import {timestampToDate} from "../../utils/util";

  export default {
    data: () => {
      return {
        loading: false, // 显示加载
        couponDialogVisible: false,
        dialogTitle: '', // 标题
        selectTableData: [],
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          order_code: '',
          cust_mobile: '',
          pay_success_time: '',
          submit_time: '',
          order_status: '',
          service_type: '90',
        },
        // 订单编号详情
        addsaleFormInline: {
          page: 1,
          rows: 10,
          order_id: '',
          sale_name: '',
          product_code: '',
          send_status: '',
          service_num: '',
        },
        listData: [], //用户数据
        couponlistData:[],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        couponpageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        order_complete_time: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        order_code: '',
        saleData: [],
        disabled: true,
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline);
    },
    mounted() {
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        serviceOrderList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        if (this.order_complete_time) {
          this.formInline.start_submit_time = timestampToDate(this.order_complete_time[0])
          this.formInline.end_submit_time = timestampToDate(this.order_complete_time[1])
        } else {
          this.formInline.start_submit_time = ''
          this.formInline.end_submit_time = ''
        }
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      // 搜索事件
      couponSearch() {
        this.addsaleFormInline.page = 1;
        this.getaddsaleata(this.addsaleFormInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      // 订单详情弹窗
      gotoOrderDetail(id, order_code) {
        this.couponDialogVisible = true;
        this.order_code = order_code;
        this.addsaleFormInline.order_id = id;
          if (this.formInline.service_type == 90) {
            this.addsaleFormInline.send_status = "0"
            this.disabled = true
          } else {
            this.addsaleFormInline.send_status = "1"
            this.disabled = false
          }
        this.getaddsaleata()
      },
      getaddsaleata() {
        serviceOrderListDetail(this.addsaleFormInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.couponlistData = res.content.rows
              this.couponlistData.forEach((item, index) => {
                item.maxnum = item.service_num
              })
              // 分页赋值
              this.couponpageparm.currentPage = this.addsaleFormInline.page
              this.couponpageparm.pageSize = this.addsaleFormInline.rows
              this.couponpageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      couponCallFather(parm) {
        this.addsaleFormInline.page = parm.currentPage
        this.addsaleFormInline.rows = parm.pageSize
        this.getaddsaleata(this.addsaleFormInline)
      },
      refundEdit() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        this.saleData = [];
        this.selectTableData.forEach((item) => {
        let param = {
          service_type: this.formInline.service_type,
          refund_priority: item.send_status == 0?"2731":"2732",
          order_id: item.order_id,
          order_item_id: item.order_item_id,
          num: item.service_num,
          sale_name: item.sale_name,
        }
        this.saleData.push(param)
        })
        param.num = this.selectTableData[0].service_num
        param.service_type = this.formInline.service_type;
        param.refund_priority = this.selectTableData[0].send_status;
        param.order_id = this.selectTableData[0].order_id;
        param.order_item_id = this.selectTableData[0].order_item_id;
        param.sale_name = this.selectTableData[0].sale_name;
        serviceAdd(this.saleData)
          .then(res => {
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功新增售后单!'
              });
              this.couponDialogVisible = false;
            }
          })
          .catch(err => {
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      handleChange(value) {
        console.log(value);
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.order_code == cell.innerText || row.cust_mobile == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
      couponCellDbClick(row, column, cell, event) {
        if (row.product_code == cell.innerText || row.sale_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
    },
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .flex_center {
    display: flex;
    align-items: center;
  }

  .layout {
    text-align: center;
    color: #409EFF;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .ml10 {
    margin-left: 10px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

</style>





// WEBPACK FOOTER //
// src/views/aftersale/addAftersale.vue